<div
  *ngIf="!isLoading"
  class="industry-menu-section"
  [ngClass]="{
    'create-new-modal-industry-menu-section': isCreateNewModalIndustryMenu
  }"
>
  <div
    class="industry-menu-content"
    [ngClass]="{
      'create-new-modal-industry-menu-content': isCreateNewModalIndustryMenu
    }"
  >
    <div
      class="industry-menu"
      [ngClass]="{
        'create-new-modal-industry-menu': isCreateNewModalIndustryMenu
      }"
    >
      <nz-tree
        nzBlockNode
        [nzData]="data"
        (nzClick)="handleMenuOnclick($event)"
        [nzTreeTemplate]="nzTreeTemplate"
        [nzSelectedKeys]="defaultKey"
        [nzExpandedKeys]="expandKey"
      >
      </nz-tree>
      <ng-template #nzTreeTemplate let-node let-origin="origin">
        <span
          class="industry-menu-item-text"
          [ngClass]="{ 'menu-highlight-text': searchedValue }"
          [innerHtml]="node.title | textHighlight: searchedValue"
        >
        </span>
        <span *ngIf="origin.count !== undefined"
          >&nbsp;({{ origin.count }})</span
        >
      </ng-template>
    </div>
    <div
      class="industry-geo-mcap-container"
      [ngClass]="{
        'geo-mcap-disabled': !isSubgroupSelected,
        'create-new-modal-industry-geo-mcap-container':
          isCreateNewModalIndustryMenu
      }"
    >
      <div class="filter-label">Filter by Market Cap</div>
      <app-market-cap-filter
        [isLoading]="isMcapGeoDataLoading"
        [marketCapData]="[marketCapData]"
        [selectedMarketCaps]="selectedMarketCaps"
        (onMarketCapSelect)="handleMarketCapChange($event)"
      ></app-market-cap-filter>
      <div class="filter-label">Filter by Geography</div>
      <app-geography-filter
        [isLoading]="isMcapGeoDataLoading"
        [geographyData]="geographyData"
        [otherGeoLen]="otherGeoLen"
        (geographySelect)="handleGeographyChange($event)"
      ></app-geography-filter>
    </div>
  </div>
  <div class="industry-menu-footer">
    {{ totalTickerCount }} companies selected
    <va-button
      btnType="outline"
      size="medium"
      (onClick)="handleCancelButtonClick()"
      class="mr-8 ml-8"
      >Cancel</va-button
    >
    <va-button
      btnType="solid"
      size="medium"
      [isDisabled]="!totalTickerCount || totalTickerCount <= 0"
      (onClick)="handleApplyButtonClick()"
      >Apply</va-button
    >
  </div>
</div>

<app-custom-skeleton
  *ngIf="isLoading"
  [customSkeletonConfig]="skeletonDefaultConfig"
  ngClass="menu-skeleton"
></app-custom-skeleton>
